import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MotiveOccurrenceComponent} from './motive-occurrence/motive-occurrence.component';
import {OccurrenceComponent} from './occurrence/occurrence.component';
import {NewOccurrenceComponent} from './new-occurrence/new-occurrence.component';
import {EquipmentVideoComponent} from './equipment-video/equipment-video.component';
import {EquipmentOperationStartComponent} from './equipment-operation-start/equipment-operation-start.component';
import {AuthGuard} from '../../core/guards/auth-guard';
import {RoleEnum} from '../../shared/enums/role.enum';
import {UserTypeEnum} from '../../shared/enums/user-type.enum';

const routes: Routes = [
  {
    path: 'motive-occurrence',
    component: MotiveOccurrenceComponent,
  },
  {
    path: 'occurrence',
    component: OccurrenceComponent,
  },
  {
    path: 'new-occurrence',
    component: NewOccurrenceComponent,
  },
  {
    path: 'equipment-video',
    canActivate: [
      () => AuthGuard(
        [RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.EQUIPMENT_VIDEO],
        true,
        [UserTypeEnum.ADMIN, UserTypeEnum.SUS, UserTypeEnum.OPR]
      )
    ],
    component: EquipmentVideoComponent,
  },
  {
    path: 'equipment-operation-start',
    canActivate: [
      () => AuthGuard(
        [RoleEnum.ADMIN_FULL, RoleEnum.GESTOR, RoleEnum.EQUIPMENT_OPERATION_START],
        true,
        [UserTypeEnum.ADMIN]
      )
    ],
    component: EquipmentOperationStartComponent,
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MonitoringRoutingModule {
}
